if (!customElements.get('ss-check-entries')) {
  customElements.define(
    'ss-check-entries',
    class SSCheckEntries extends HTMLElement {
      connectedCallback() {
        // Reparenting the modal to <body> means a second connect (the element
        // being moved, or reconnected in the theme editor) must not re-run setup.
        if (this.initialized) return;
        this.initialized = true;

        this.apiBase = (this.dataset.apiBase || '').replace(/\/+$/, '');
        this.shop = this.dataset.shop;
        this.giveawayId = this.dataset.giveawayId;

        this.trigger = this.querySelector('[data-ss-open]');
        this.modal = this.querySelector('[data-ss-modal]');

        if (!this.trigger || !this.modal) return;

        document.body.appendChild(this.modal);

        this.form = this.modal.querySelector('[data-ss-form]');
        this.input = this.modal.querySelector('[data-ss-email]');
        this.submit = this.modal.querySelector('[data-ss-submit]');
        this.submitLabel = this.modal.querySelector('[data-ss-submit-label]');
        this.message = this.modal.querySelector('[data-ss-message]');
        this.result = this.modal.querySelector('[data-ss-result]');
        this.count = this.modal.querySelector('[data-ss-count]');
        this.countLabel = this.modal.querySelector('[data-ss-count-label]');

        this.onKeydown = this.onKeydown.bind(this);

        this.trigger.addEventListener('click', this.open.bind(this));
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.modal.querySelectorAll('[data-ss-close]').forEach((el) => {
          el.addEventListener('click', this.close.bind(this));
        });
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        document.body.style.overflow = '';
        setTimeout(() => {
          if (!this.isConnected && this.modal) this.modal.remove();
        }, 0);
      }

      open(event) {
        event.preventDefault();
        this.modal.hidden = false;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKeydown);
        this.input.focus();
        this.input.select();

        if (this.dataset.autoFetch === 'true' && !this.hasFetched && this.input.value) {
          this.hasFetched = true;
          this.fetchEntries(this.input.value);
        }
      }

      close() {
        this.modal.hidden = true;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.onKeydown);
        this.trigger.focus();
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.close();
      }

      onSubmit(event) {
        event.preventDefault();
        this.fetchEntries(this.input.value);
      }

      setMessage(text) {
        this.message.textContent = text || '';
        this.message.hidden = !text;
      }

      setLoading(loading) {
        this.submit.disabled = loading;
        this.submitLabel.textContent = loading
          ? this.dataset.loadingLabel
          : this.dataset.submitLabel;
      }

      async fetchEntries(rawEmail) {
        const email = (rawEmail || '').trim();
        if (!email) {
          this.setMessage(this.dataset.errorEmail);
          return;
        }

        this.setMessage('');
        this.result.hidden = true;
        this.setLoading(true);

        try {
          const url = `${this.apiBase}/customer-entries-by-email?email=${encodeURIComponent(
            email
          )}&giveawayId=${encodeURIComponent(this.giveawayId)}`;

          const response = await fetch(url, {
            method: 'GET',
            headers: { 'X-Shopify-Shop-Domain': this.shop },
          });

          if (!response.ok) {
            this.setMessage(this.dataset.errorGeneric);
            return;
          }

          const data = await response.json();
          const total = Number(data.totalEntriesEarned) || 0;

          this.count.textContent = total.toLocaleString();
          this.countLabel.textContent =
            total === 1 ? this.dataset.labelSingular : this.dataset.labelPlural;
          this.result.hidden = false;
        } catch (error) {
          this.setMessage(this.dataset.errorGeneric);
        } finally {
          this.setLoading(false);
        }
      }
    }
  );
}
